import * as API from 'src/helpers/api_helper'
import * as URL from 'src/helpers/url_helper'

//

export const PlansListApi = (data) => API.get(`${URL.PLANS_LIST_URL}`, data)
